export default "__VITE_ASSET__BqkcudPn__"